// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.p-breadcrumb .p-menuitem:last-child .p-menuitem-link {
  font-weight: bold;
  color: blue;
}

.sidebar {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 999;
}

.sidebar-inner-wrapper {
  height: 100%;
  overflow-y: scroll;
  overflow-x: hidden;
  scrollbar-width: none;
}

.sidebar-inner-wrapper::-webkit-scrollbar {
  width: 0;
}

/* Стили для информации о версии */
.sidebar-main .text-400.text-sm {
  position: absolute;
  top: 25px;
}

/* Стили для иконки пользователя */
.isUser-icon {
  height: 55px;
  width: 55px;
  border-radius: 50%;
  position: relative;
}

.isUser-icon img {
  width: 100%;
  height: 100%;
  border-radius: 50%;
  object-fit: cover;
}


.departments-list {
  list-style: none;
  padding-left: 1.25rem;
}

.departments-list li {
  position: relative;
}

.departments-list li::before {
  content: "-";
  position: absolute;
  left: -1rem;
  color: #6b7280;
}

.departments-list li:not(:last-child) {
  margin-bottom: 0.125rem;
}`, "",{"version":3,"sources":["webpack://./src/ui/css/SidebarNavigation.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,QAAQ;AACV;;AAEA,kCAAkC;AAClC;EACE,kBAAkB;EAClB,SAAS;AACX;;AAEA,kCAAkC;AAClC;EACE,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;AACnB;;;AAGA;EACE,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,WAAW;EACX,cAAc;AAChB;;AAEA;EACE,uBAAuB;AACzB","sourcesContent":[".p-breadcrumb .p-menuitem:last-child .p-menuitem-link {\n  font-weight: bold;\n  color: blue;\n}\n\n.sidebar {\n  position: fixed;\n  top: 0;\n  left: 0;\n  z-index: 999;\n}\n\n.sidebar-inner-wrapper {\n  height: 100%;\n  overflow-y: scroll;\n  overflow-x: hidden;\n  scrollbar-width: none;\n}\n\n.sidebar-inner-wrapper::-webkit-scrollbar {\n  width: 0;\n}\n\n/* Стили для информации о версии */\n.sidebar-main .text-400.text-sm {\n  position: absolute;\n  top: 25px;\n}\n\n/* Стили для иконки пользователя */\n.isUser-icon {\n  height: 55px;\n  width: 55px;\n  border-radius: 50%;\n  position: relative;\n}\n\n.isUser-icon img {\n  width: 100%;\n  height: 100%;\n  border-radius: 50%;\n  object-fit: cover;\n}\n\n\n.departments-list {\n  list-style: none;\n  padding-left: 1.25rem;\n}\n\n.departments-list li {\n  position: relative;\n}\n\n.departments-list li::before {\n  content: \"-\";\n  position: absolute;\n  left: -1rem;\n  color: #6b7280;\n}\n\n.departments-list li:not(:last-child) {\n  margin-bottom: 0.125rem;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
